module.exports = __webpack_public_path__ + "0e943c48b8a95eda459b9bcfb3366557.svg";